import { ApiError, NetworkError } from '../api/client';

export type PassField = 'plate' | 'name' | 'model' | 'vehicleType';

export interface PassErrorView {
  /** Shown above the submit button. */
  general: string | null;
  /** Shown under the field. */
  fields: Partial<Record<PassField, string>>;
}

const TEXTS: Record<string, string> = {
  PASSES_QUOTA_EXCEEDED: 'Лимит пропусков на этот адрес исчерпан',
  NOT_ALLOWED_CAR_PASSES: 'Этот тип пропуска на объекте недоступен',
  NOT_ALLOWED_PEDESTRIAN_PASSES: 'Этот тип пропуска на объекте недоступен',
  PASS_TYPE_RESTRICTED: 'Этот тип пропуска на объекте недоступен',
  DURATION_TYPE_RESTRICTED: 'Этот тип пропуска на объекте недоступен',
  ACCESS_RESTRICTED: 'УК ограничила доступ — позвоните в УК',
  PASSES_DUPLICATE: 'Такой пропуск уже оформлен',
  REQUESTS_QUOTA_EXCEEDED: 'Лимит заявок исчерпан',
  DUPLICATE_REQUEST: 'Такая заявка уже отправлена',
  REQUESTS_PER_MINUTE_LIMIT_EXCEEDED: 'Слишком часто, повторите через минуту',
  UPDATE_INSIDE_PASS: 'Гость на территории — закрыть можно после выезда',
  CLOSED_PASS: 'Пропуск уже закрыт',
  REQUEST_IS_CLOSED: 'Обращение закрыто',
};

const FIELD_OF: Record<string, PassField> = {
  'guestData.plateNumber': 'plate',
  'guestData.name': 'name',
  'guestData.modelId': 'model',
  'guestData.vehicleType': 'vehicleType',
};

/** Error of POST /v1/passes or /v1/requests → texts at the place of action (spec §7.1). */
export function describePassError(error: unknown): PassErrorView {
  if (error instanceof NetworkError) return { general: 'Нет связи. Проверьте интернет и попробуйте ещё раз', fields: {} };
  if (!(error instanceof ApiError)) return { general: 'Не получилось оформить. Попробуйте ещё раз', fields: {} };

  if (error.code === 'VALIDATION_ERROR' && error.details) {
    const fields: PassErrorView['fields'] = {};
    const rest: string[] = [];
    for (const [key, messages] of Object.entries(error.details)) {
      const field = FIELD_OF[key];
      if (field) fields[field] = messages[0];
      else rest.push(messages[0]);
    }
    return { general: rest[0] ?? null, fields };
  }
  return { general: TEXTS[error.code] ?? error.message, fields: {} };
}
